import { makeObservable, observable, action } from 'mobx';

export type FitnessLevelType = 'beginner' | 'intermediate' | 'advanced';

export class FitnessLevelStore {
  selectedFitnessLevel: FitnessLevelType | null = null;

  constructor() {
    makeObservable(this, {
      selectedFitnessLevel: observable,
      setFitnessLevel: action,
    });
  }

  setFitnessLevel(inputFitnessLevel: FitnessLevelType) {
    this.selectedFitnessLevel = inputFitnessLevel;
  }
}

export const fitnessLevelStore = new FitnessLevelStore();
